import * as Yup from 'yup';
const allowedPmsValues = ['streamline', 'guesty', 'hospitable', 'hostfully', 'track', 'other'];

const loginSchema = Yup.object({
  email: Yup.string().email('Please enter a valid email').lowercase().required('Required'),
})


const forgetSchema = Yup.object({
  email: Yup.string().email('Please enter a valid email').lowercase().required('Required'),
})

const forgotPasswordSchema = Yup.object({
  newPassword: Yup.string()
    .min(8, 'New password must be at least 8 characters long')
    .matches(/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/, 'Password must contain at least one uppercase letter, one lowercase letter, and one number or special character')
    .required('Required')
})

const resetSchema = Yup.object({
  newPassword: Yup.string()
    .min(8, 'New password must be at least 8 characters long')
    .matches(/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/, 'Password must contain at least one uppercase letter, one lowercase letter, and one number or special character')
    .required('Required'),
  oldPassword: Yup.string()
    .min(8, 'Old password must be at least 8 characters long')
    .matches(/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/, 'Password must contain at least one uppercase letter, one lowercase letter, and one number or special character')
    .required('Required')
})

const registrationSchema = Yup.object().shape({
  email: Yup.string().email('Please enter a valid email').lowercase().required('Email is Required'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters long')
    .matches(/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/, 'Password must contain at least one uppercase letter, one lowercase letter, and one number or special character')
    .required('Required'),
  firstName: Yup.string().required('FirstName is Required'),
  lastName: Yup.string().required('LastName is Required'),
  phoneNumber: Yup.string().min(10, 'Please enter a valid phone number').required('phoneNumber is Required'),
  address: Yup.object().shape({
    line1: Yup.string().required('Address is Required'),
    city: Yup.string().required('Please specify your city'),
    state: Yup.string().required('Please specify your state'),
    zipCode: Yup.string().matches(/^\d{5}(?:[-\s]\d{4})?$/, 'Please enter a valid zip code').required('ZipCode is Required'),
  }),
  propertyManagementSoftware: Yup.string()
    .trim()
    .lowercase()
    .oneOf(allowedPmsValues, 'Please select a valid property management software')
    .required('Please select your property management software'),
  companyName: Yup.string().required('Company Name is required'),
  selfOnboarding: Yup.boolean().required("Please choose whether you're self-signing up or onboarding with a Bellhopt Team member.")
});


export { loginSchema, registrationSchema, forgetSchema, resetSchema, forgotPasswordSchema }
